/* stylelint-disable max-nesting-depth */

/**
    @prop --uic-tooltip-border-color: border color of the tooltip panel
    @prop --uic-tooltip-border-color-error: border color of the tooltip panel for error variant
    @prop --uic-tooltip-background-color: background color of the tooltip panel
    @prop --uic-tooltip-z-index: z-index of the tooltip panel
*/

uic-tooltip {
  display: contents;
  position: relative;
  user-select: none;
}

uic-tooltip[open] {
  .uic-tooltip__positioner {
    pointer-events: auto;
  }

  .uic-tooltip__content {
    opacity: 1;
  }
}

uic-tooltip[disabled] {
  .uic-tooltip__over {
    cursor: default;
  }
}

uic-tooltip[error] {
  .uic-tooltip__content {
    border-color: var(--uic-tooltip-border-color-error);
    box-shadow: 0 0 4px 0 var(--uic-atom-shadow-color-error);
  }

  .uic-tooltip__positioner[data-popper-placement='top-end'] .uic-tooltip__content,
  .uic-tooltip__positioner[data-popper-placement='bottom-end'] .uic-tooltip__content {
    &::after {
      border-color: transparent var(--uic-tooltip-border-color-error) transparent transparent;
    }
  }

  .uic-tooltip__positioner[data-popper-placement='top-start'] .uic-tooltip__content,
  .uic-tooltip__positioner[data-popper-placement='bottom-start'] .uic-tooltip__content {
    &::after {
      border-color: transparent transparent transparent var(--uic-tooltip-border-color-error);
    }
  }
}

.uic-tooltip {
  &__over {
    cursor: help;
    display: inline-block;
    touch-action: none;

    uic-icon:first-child:last-child {
      display: block;
    }
  }

  &__positioner {
    pointer-events: none;
    position: absolute;
    z-index: var(--uic-tooltip-z-index, 1000);
  }

  &__content {
    background-color: var(--uic-tooltip-background-color);
    border: 1px solid var(--uic-tooltip-border-color);
    box-shadow: 0 0 6px 0 var(--uic-color-blue6);
    font-size: 0.8rem;
    line-height: 16px;
    opacity: 0;
    padding: 8px 12px;
    position: relative;
    text-align: left;
    white-space: normal;

    &::after {
      content: '';
      height: 0;
      position: absolute;
      width: 0;
    }

    &::before {
      content: '';
      height: 0;
      position: absolute;
      width: 0;
    }

    @media #{$breakpoint_tablet} {
      min-width: 112px;
    }

    @media #{$breakpoint_desktop} {
      min-width: 134px;
    }
  }

  &__content--restricted-width {
    @media #{$breakpoint_tablet} {
      max-width: 192px;
    }

    @media #{$breakpoint_desktop} {
      max-width: 230px;
    }
  }

  &__close-button {
    position: absolute;
    right: 8px;
    top: 8px;
  }

  &__content--closeable {
    padding: calc(var(--uic-icon-button-height) / 2) calc(var(--uic-icon-button-width) + 16px)
      calc(var(--uic-icon-button-height) / 2) 16px;
  }
}

.uic-tooltip__positioner[data-popper-placement='top-start'] .uic-tooltip__content {
  &::after {
    border-bottom: 13px solid transparent;
    border-left: 13px solid var(--uic-tooltip-border-color);
    bottom: -13px;
    left: -1px;
  }

  &::before {
    border-bottom: 11px solid transparent;
    border-left: 11px solid var(--uic-tooltip-background-color);
    bottom: -11px;
    left: 0;
    z-index: 10;
  }
}

.uic-tooltip__positioner[data-popper-placement='top-end'] .uic-tooltip__content {
  &::after {
    border-bottom: 13px solid transparent;
    border-right: 13px solid var(--uic-tooltip-border-color);
    bottom: -13px;
    right: -1px;
  }

  &::before {
    border-bottom: 11px solid transparent;
    border-right: 11px solid var(--uic-tooltip-background-color);
    bottom: -11px;
    right: 0;
    z-index: 10;
  }
}

.uic-tooltip__positioner[data-popper-placement='bottom-start'] .uic-tooltip__content {
  &::after {
    border-left: 13px solid var(--uic-tooltip-border-color);
    border-top: 13px solid transparent;
    left: -1px;
    top: -13px;
  }

  &::before {
    border-left: 11px solid var(--uic-tooltip-background-color);
    border-top: 11px solid transparent;
    left: 0;
    top: -11px;
    z-index: 10;
  }
}

.uic-tooltip__positioner[data-popper-placement='bottom-end'] .uic-tooltip__content {
  &::after {
    border-right: 13px solid var(--uic-tooltip-border-color);
    border-top: 13px solid transparent;
    right: -1px;
    top: -13px;
  }

  &::before {
    border-right: 11px solid var(--uic-tooltip-background-color);
    border-top: 11px solid transparent;
    right: 0;
    top: -11px;
    z-index: 10;
  }
}
